import axios from 'axios';
import iconv from 'iconv-lite';

axios.interceptors.response.use((response) => {
  let ctype = response.headers['content-type'];
  if (ctype.includes('charset=ISO-8859-1')) {
    response.data = iconv.decode(response.data, 'ISO-8859-1');
  }
  return response;
});

const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
});

export default http;

export const apiDmars = axios.create({
  baseURL: process.env.REACT_APP_DMARS_API_URL,
});

const DMARS_TOKEN_KEY = 'dmars_token';
let dmarsTokenPromise = null;

const requestDmarsToken = () => {
  return http.get('Usuario/GenerarDmarsApiToken');
};

const getDmarsToken = () => {
  const cached = localStorage.getItem(DMARS_TOKEN_KEY);
  if (cached) return Promise.resolve(cached);

  if (!dmarsTokenPromise) {
    dmarsTokenPromise = requestDmarsToken()
      .then((res) => {
        const token = res.data.accessToken;
        localStorage.setItem(DMARS_TOKEN_KEY, token);
        return token;
      })
      .finally(() => {
        dmarsTokenPromise = null;
      });
  }

  return dmarsTokenPromise;
};

apiDmars.interceptors.request.use(async (config) => {
  const token = await getDmarsToken();
  config.headers.Authorization = 'Bearer ' + token;
  return config;
});

apiDmars.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const config = error.config;
    if (error.response && error.response.status === 401 && !config._retry) {
      config._retry = true;
      try {
        localStorage.removeItem(DMARS_TOKEN_KEY);
        const token = await getDmarsToken();
        config.headers.Authorization = 'Bearer ' + token;
        return apiDmars(config);
      } catch (err) {
        return Promise.reject(err);
      }
    }
    return Promise.reject(error);
  }
);

export const config = {
  headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
};
